<template>
  <div id="app">
    <!--<router-view/>-->
  </div>
</template>

<script>
import Api from './apis/api';
export default {
  name: 'App',
  methods: {
    initComyinfo(loc,param) {
      let reqDomainparams = {
          reqdomain: loc,
          terminaltype: 0,
      }
      Api.INITMODEL(reqDomainparams).then(res => {
          if (res.data.status == '001') {
              let mobList = res.data.data
              let mob = ""
              if(mobList) {
              mobList.some(item => {
                if(item.type == 1) {
                  mob = JSON.parse(item.mallcontent).turl
                  return true
                }
              })
            }
            // 线上 ----------------------------------------------------------- 线上 
            if(param) {
              window.location.href = `https://${loc}/${mob}.html#/${param}`
            } else {
              window.location.href = `https://${loc}/${mob}.html`
            }

            // // 测试 ----------------------------------------------------------- 测试
            // if(param) {
            //   window.location.href = `http://${loc}/${mob}.html#/${param}`
            // } else {
            //   window.location.href = `http://${loc}/${mob}.html`
            // }

            // // 线下 ------------------------------------------------------------- 线下
            // let host = location.host
            // window.location.href = `http://${host}/${mob}.html`
          }
      }).catch(function () {
      })
    }
  },
  mounted() {
    // 线上 --------------------------------------------------------- 线上
    let host =  location.host;
    let http = ""; // 路径前缀
    let index = host.indexOf(".");
    http = host.substring(0, index);
    let otherUrls = host.substring(index);
    let urlStings = '.cutmall.cn,.th512.com,.2wbuy.cn'; // 16、17、18的域名后缀
    let loc = location.host
    let urls = '.cutmall.cn' // 需要改变的后缀名
    if (urlStings.indexOf(otherUrls) != -1) {
      loc = http + urls
     }
    let url = ""; // 是否带有路由
    let test = window.location.href
    let indexs = test.indexOf(".cn/")
    if(indexs != -1) {
      url = test.substring(indexs + 4)
    }

    // // 测试 --------------------------------------------------------- 测试
    // let host =  location.host;
    // let http = ""; // 路径前缀
    // let index = host.indexOf(".");
    // http = host.substring(0, index);
    // let otherUrls = host.substring(index);
    // let urlStings = '.cutmall.cn,.th512.com,.2wbuy.cn'; // 16、17、18的域名后缀
    // let loc = location.host
    // let urls = '.maboy.cn' // 需要改变的后缀名
    // if (urlStings.indexOf(otherUrls) != -1) {
    //   loc = http + urls
    //  }
    // let url = ""; // 是否带有路由
    // let test = window.location.href
    // let indexs = test.indexOf(".cn/")
    // if(indexs != -1) {
    //   url = test.substring(indexs + 4)
    // }

    // // 线下 ------------------------------------------------------ 线下
    // let loc = 'jht.th28.cn'
    // let url = ""; // 是否带有路由

    this.initComyinfo(loc,url)
  }
}
</script>

<style scoped>
#app {
   width:100%;
  height:100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue